<template>
  <div class="container language">
    <!-- 搜索栏 -->
    <div class="language-bar">
      <el-form :inline="true" :model="language" class="form-inline">
        <el-form-item label="关键词">
          <el-input
            v-model="language.keyWord"
            placeholder="搜索关键词"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="language.timeRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="paperworkListByKey">查询</el-button>
          <el-button type="success" @click="openAddDialog"
            >添加转发语</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 文案列表 -->
    <div class="language-container">
      <div class="language-container-title">文案转发语列表</div>
      <div class="language-container-item">
        <div
          class="item"
          v-for="(item, index) in paperworkList"
          :key="`paperwork-${index}`"
        >
          <div class="title">
            {{ item.userName }}
          </div>
          <div class="content">{{ item.paperwork }}</div>
          <div class="func">
            <div @click="copyLanguage(item.paperwork)">
              <SvgComponent icon-name="copy" />
              <div>复制</div>
            </div>
            <div @click="editorLanguage(item.paperwork)">
              <SvgComponent icon-name="editor-language" />
              <div>编辑</div>
            </div>
            <div @click="handleCollect(item)">
              <SvgComponent icon-name="collect" />
              <div>收藏</div>
            </div>
          </div>
        </div>
      </div>
      <div class="language-container-page">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="limit"
          @current-change="handleCurrentChange"
          @prev-click="handlePrevClick"
          @next-click="handleNextClick"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog
      :visible.sync="languageDialog"
      width="30%"
      :close-on-click-modal="false"
      @open="handleDialogOpen"
      @close="handleDialogClose"
    >
      <span slot="title" class="dialog-title">
        <SvgComponent icon-name="languageTitle" />
        <div>编辑转发语</div>
      </span>

      <div class="dialog-content">
        <el-input
          ref="editorInput"
          type="textarea"
          autosize
          v-model="editorLanguageWord"
          @focus="handleEditorFocus"
          @blur="handleEditorBlur"
        ></el-input>
      </div>

      <div class="dialog-func">
        <i class="iconfont icon-zuoduiqi pointer" @click="leftJustify"></i>
        <i
          class="iconfont icon-juzhongduiqi pointer"
          @click="centerJustify"
        ></i>
        <el-dropdown @command="formatSelectedText">
          <span class="el-dropdown-link">
            <i class="iconfont icon-case pointer"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in fontMapOptions"
              :key="`font-${index}`"
              :command="item.key"
              >{{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="languageDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleDialogSure">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加转发语对话框 -->
    <el-dialog
      :visible.sync="addDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      title="添加转发语"
    >
      <el-form :model="addForm" label-width="80px">
        <el-form-item label="作者">
          <el-input v-model="userName" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="转发语">
          <el-input
            type="textarea"
            :rows="6"
            v-model="addForm.paperwork"
            placeholder="请输入转发语内容..."
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddDialogSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SvgComponent from "../components/SvgComponent";
import { FONT_MAPS } from "../utilis/enum";
import { mapActions, mapGetters } from "vuex";
import { Loading } from "element-ui";

export default {
  name: "Language",
  components: {
    SvgComponent,
  },
  data() {
    return {
      language: {
        keyWord: "",
        timeRange: "",
      },
      languageDialog: false,
      editorLanguageWord: "",
      cursorPosition: 0,
      isEditorFocused: false,
      fontMaps: FONT_MAPS,
      page: 1,
      addDialogVisible: false,
      addForm: {
        userName: "",
        paperwork: "",
      },
    };
  },

  async mounted() {
    await this.select();
  },

  methods: {
    ...mapActions("paperwork", ["selectByPage", "insertPaperworkByUserName"]),

    async select() {
      const loadingInstance = Loading.service({});
      await this.selectByPage({
        keyword: this.language.keyWord,
        page: this.page,
      });
      loadingInstance.close();
    },

    // 打开添加对话框
    openAddDialog() {
      this.addForm = {
        userName: "",
        paperwork: "",
      };
      this.addDialogVisible = true;
    },

    // 处理添加对话框确认
    async handleAddDialogSure() {
      if (!this.addForm.paperwork.trim()) {
        this.$message.warning("请输入转发语内容");
        return;
      }
      console.log(this.addForm);
      try {
        const response = await this.insertPaperworkByUserName({
          userName: this.userName,
          paperwork: this.addForm.paperwork,
        });
        console.log(response);
        this.$message.success("添加成功");
        this.addDialogVisible = false;
        await this.select();
      } catch (error) {
        console.error("添加失败:", error);
        this.$message.error("添加失败");
      }
    },

    async paperworkListByKey() {
      this.page = 1;
      await this.select();
    },

    async copyLanguage(text) {
      if (!text) {
        this.$message.error("请复制文本");
        return;
      }

      try {
        // 使用现代API复制文本
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
        }

        this.$message.success("文本已复制到剪切板");
      } catch (err) {
        console.error("复制失败:", err);
        this.$message.error("复制失败");
      }
    },

    // 打开编辑对话框
    editorLanguage(event) {
      this.editorLanguageWord = event;
      this.languageDialog = true;
    },

    // 处理对话框打开
    handleDialogOpen() {
      this.$nextTick(() => {
        this.$refs.editorInput.focus();
      });
    },

    // 处理对话框关闭
    handleDialogClose() {
      this.cursorPosition = 0;
    },

    // 输入框聚焦时记录光标位置
    handleEditorFocus() {
      this.isEditorFocused = true;
      const textarea = this.getTextareaElement();
      if (textarea) {
        this.cursorPosition = textarea.selectionStart || 0;
      }
    },

    // 输入框失焦时记录光标位置
    handleEditorBlur() {
      this.isEditorFocused = false;
      const textarea = this.getTextareaElement();
      if (textarea) {
        this.cursorPosition = textarea.selectionStart || 0;
      }
    },

    leftJustify() {
      const newWord = this.editorLanguageWord.split("\n");
      this.editorLanguageWord = newWord
        .map((line) => line.trimStart())
        .join("\n");
      this.$message.success("已完成左对齐");
    },

    centerJustify(options = {}) {
      const {
        tabSize = 4, // 制表符宽度
        strictCheck = false, // 严格检查或宽松检查
      } = options;

      const lines = this.editorLanguageWord.split("\n");
      if (lines.length === 0) return "";

      // 计算基准宽度
      const baseWidth = this.calculateWidth(lines[0], tabSize);

      // 检查后续行
      let canCenter = true;

      for (let i = 1; i < lines.length; i++) {
        const lineWidth = this.calculateWidth(lines[i], tabSize);

        if (strictCheck) {
          // 严格检查：必须完全小于等于基准宽度
          if (lineWidth > baseWidth) {
            canCenter = false;
            break;
          }
        } else {
          // 宽松检查：允许一定的误差范围（考虑字体渲染差异）
          if (lineWidth > baseWidth * 1.2) {
            // 允许20%的误差
            canCenter = false;
            break;
          }
        }
      }

      if (!canCenter) {
        return this.editorLanguageWord;
      }

      // 对齐操作
      const centeredLines = lines.map((line) => {
        const lineWidth = this.calculateWidth(line, tabSize);

        if (lineWidth >= baseWidth) return line;

        // 计算需要添加的空格数
        const spacesNeeded = baseWidth - lineWidth;
        const leftSpaces = Math.floor(spacesNeeded / 2);
        const rightSpaces = spacesNeeded - leftSpaces;

        return " ".repeat(leftSpaces) + line + " ".repeat(rightSpaces);
      });

      this.editorLanguageWord = centeredLines.join("\n");
    },

    // 统一的宽度计算函数
    calculateWidth(str, tabSize = 4) {
      let width = 0;

      for (let char of str) {
        const code = char.charCodeAt(0);

        // 处理制表符
        if (code === 9) {
          // \t
          width += tabSize;
        }
        // 处理全角字符
        else if (this.isFullWidthChar(char)) {
          width += 2;
        }
        // 处理半角字符
        else {
          width += 1;
        }
      }

      return width;
    },

    // 判断是否为全角字符
    isFullWidthChar(char) {
      const code = char.charCodeAt(0);

      // 全角字符范围
      return (
        // 中日韩文字
        (code >= 0x4e00 && code <= 0x9fff) ||
        // 中文标点
        (code >= 0x3000 && code <= 0x303f) ||
        // 全角字母、数字、符号
        (code >= 0xff00 && code <= 0xffef) ||
        // 其他全角字符
        (code >= 0xfe30 && code <= 0xfe4f)
      );
    },

    // 获取原生 textarea 元素的辅助方法
    getTextareaElement() {
      if (!this.$refs.editorInput) return null;
      return this.$refs.editorInput.$el.querySelector("textarea");
    },

    formatSelectedText(command) {
      const style = command || "math-bold";

      try {
        // 获取原生 textarea 元素
        const textarea = this.getTextareaElement();
        if (!textarea) {
          this.$message.error("找不到编辑器");
          return;
        }

        // 确保获得焦点
        textarea.focus();

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        // 如果没有选中文字，则提示用户
        if (start === end) {
          this.$message.warning("请先选择要转换的文字");
          return;
        }

        const selectedText = this.editorLanguageWord.substring(start, end);
        let convertedText = "";

        // 获取对应的映射表
        let map = this.fontMaps[style];
        if (!map) {
          console.warn(`字体样式"${style}"不存在，使用默认数学加粗样式`);
          map = this.fontMaps["math-bold"];
        }

        // 安全转换每个字符
        for (let char of selectedText) {
          // 如果映射表中存在该字符，则使用映射字符，否则使用原字符
          if (map[char] !== undefined) {
            convertedText += map[char];
          } else {
            // 尝试转换大小写
            const upperChar = char.toUpperCase();
            const lowerChar = char.toLowerCase();

            if (char !== upperChar && map[upperChar] !== undefined) {
              convertedText += map[upperChar];
            } else if (char !== lowerChar && map[lowerChar] !== undefined) {
              convertedText += map[lowerChar];
            } else {
              convertedText += char;
            }
          }
        }

        // 替换选中文本
        const beforeText = this.editorLanguageWord.substring(0, start);
        const afterText = this.editorLanguageWord.substring(end);
        this.editorLanguageWord = beforeText + convertedText + afterText;

        // 恢复光标位置
        this.$nextTick(() => {
          textarea.focus();
          textarea.setSelectionRange(start, start + convertedText.length);

          // 显示成功消息
          const styleNames = {
            "math-bold": "数学加粗",
            "math-italic": "数学斜体",
            circled: "圆圈体",
            fullwidth: "全角体",
          };

          this.$message.success(`已转换为${styleNames[style] || style}字体`);
        });
      } catch (error) {
        console.error("字体转换失败:", error);
        this.$message.error("字体转换失败，请重试");
      }
    },

    handleDialogSure() {
      this.copyLanguage(this.editorLanguageWord);
      this.languageDialog = false;
    },

    // 收藏功能
    async handleCollect() {},

    async handleCurrentChange(val) {
      this.page = val;
      await this.select();
    },

    async handlePrevClick(val) {
      this.page = val;
      await this.select();
    },

    async handleNextClick(val) {
      this.page = val;
      await this.select();
    },
  },

  computed: {
    ...mapGetters("paperwork", [
      "count",
      "paperworkList",
      "pages",
      "total",
      "limit",
    ]),
    ...mapGetters("user", ["userName"]),
    fontMapOptions() {
      return [
        { key: "math-bold", label: "𝐁数学加粗" },
        { key: "math-italic", label: "𝐴数学斜体" },
        { key: "circled", label: "ⓒ圆圈体" },
        { key: "fullwidth", label: "Ｆ全角体" },
        { key: "gothic", label: "𝔊哥特体" },
        { key: "script", label: "𝒞手写体" },
        { key: "smallcaps", label: "s小型大写" },
      ];
    },
  },

  watch: {
    editorLanguageWord: {
      handler: function (newVal) {
        const languageRows = newVal.split("\n").length;
        if (languageRows > 6) {
          this.$message.error("转发语超过6行，将会折叠，建议缩短字段");
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index";

.language {
  background-color: $help_back_color;
  border-radius: $main_border_radius;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;

  .language-bar {
    margin: 20px;
    height: 40px;
    width: calc(100% - 80px);
    background-color: #ffffff;
    border-radius: $main_border_radius;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;

    .form-inline {
      display: flex;
      align-items: center;

      .el-form-item {
        vertical-align: center;
        margin-bottom: 0;
      }
    }
  }

  .language-container {
    margin: 0 20px;
    padding: 20px;
    width: calc(100% - 80px);
    background-color: #ffffff;
    border-radius: $main_border_radius;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;

    .language-container-title {
      font-weight: bolder;
      color: $main_font_color;
      font-size: 0.9rem;
    }

    .language-container-item {
      flex: 1;
      padding: 20px 0;
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-gap: 10px;
      grid-auto-rows: 1fr;
      min-height: 0;

      .item {
        min-width: 0;
        border: 1px solid #d7dae2;
        border-radius: $main_border_radius;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          color: $main_font_color;
          font-size: 0.8rem;
          font-weight: bolder;
          background-color: #e8f1ff;
          padding: 6px 10px;
        }

        .content {
          white-space: pre-line;
          font-size: 0.8rem;
          line-height: 2;
          color: $help_font_color;
          padding: 2px 10px;
          flex-grow: 1;
          display: flex;
          align-items: center;
        }

        .func {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-size: 0.8rem;
          color: $help_font_color;
          gap: 10px;
          padding: 0px 10px 10px 10px;

          & > div {
            display: flex;
            flex-direction: row;
            cursor: pointer;
            align-items: center;

            & > div {
              margin-left: 4px;
            }
          }
        }
      }
    }

    .language-container-page {
      text-align: right;
      margin-top: 20px;
    }
  }
}

.el-dialog {
  .dialog-title {
    display: flex;
    flex-direction: row;
    gap: 4px;
  }

  .dialog-content {
  }

  .dialog-func {
    margin-top: 20px;
    display: flex;
    gap: 10px;
  }
}
</style>
